<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue" @cancel="preventLeavingWithUnsavedChanges"
                                    :disable-save="!config.isDirty">
        <Alert v-if="loadingStoresFailed"
               :title="__(`integrations.${integration.code}.loading_stores_failed_title`)"
               type="light-danger"
               class="mb-6"
        >
            <template v-slot:icon>
                <i class="fas fa-exclamation-triangle"/>
            </template>
            <template v-slot:default>
                {{ __(`integrations.${integration.code}.loading_stores_failed`) }}
            </template>
        </Alert>

        <!-- STORE ID -->
        <FormGroupNew :label="__('general.store_number')"
                      :description="__('actions.select_thing', {thing: __('general.store_number')})"
                      :error="config.errors.hiltes_store_id"
                      :required="requiredFields.includes('hiltes_store_id')">
            <input v-if="loadingStoresFailed"
                   type="number"
                   class="form-control"
                   v-model="config.hiltes_store_id"
            >
            <SearchableRadioGroup v-else
                                  :things="__('general.stores')"
                                  :options="radioGroupOptions"
                                  :show-search="totalStores > 5"
                                  :loading="loadingStores"
                                  v-model="config.hiltes_store_id"
            />
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import IntegrationRoutesMixin from "@mixins/IntegrationRoutesMixin";
import RadioGroup from "@components/Inputs/RadioGroup.vue";
import Alert from "@components/Alert.vue";
import SearchableRadioGroup from "@components/Inputs/SearchableRadioGroup.vue";

export default {
    components: {
        SearchableRadioGroup,
        Alert,
        RadioGroup,
        FormGroupNew,
        IntegrationStoreSettingsLayout,
    },

    mixins: [IntegrationStoreConfigMixin, IntegrationRoutesMixin],

    data() {
        return {
            hiltesStores: [],
            loadingStores: false,
            loadingStoresFailed: false
        }
    },

    mounted() {
        this.loadHiltesStores();
    },

    methods: {
        loadHiltesStores() {
            this.loadingStores = true;
            axios.post(this.integrationRoute('stores'), {
                firebase_uid: this.$page.props.user.firebase_uid
            }).then(response => {
                this.hiltesStores = response.data;
                this.loadingStores = false;
            }).catch(errorResponse => {
                logDev('Error loading HILTES stores.', errorResponse.response.data)
                this.loadingStoresFailed = true;
                this.loadingStores = false;
            })
        }
    },

    computed: {
        radioGroupOptions() {
            let options = {};

            for (let store of this.hiltesStores) {
                let values = [
                    store.Description,
                    store.PostCode,
                    store.NameOfCity,
                    store.Address
                ].filter((item) => {
                    let trimmed = item.trim();
                    return trimmed !== '.' && trimmed !== '';
                });

                options[`<b>[${store.Number}]</b> ${values.join(', ')}`] = store.Number.toString();
            }

            return options;
        },

        totalStores() {
            return this.hiltesStores.length;
        }
    }
}
</script>
